const initialState = {
  loading: false,
  communities: [],
  featuredCampaigns: [],
  pagination: {
    pageNumber: 1,
    pageSize: 9
  },
  filter: {
    name: ''
  }
};

const communityListings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_FOR_COMMUNITY_LISTINGS':
    case 'FOLLOW_COMPANY_COMMUNITY_REQUEST':
    case 'FOLLOW_COMPANY_COMMUNITY_SUCCESS':
    case 'FOLLOW_COMPANY_COMMUNITY_FAILED':
    case 'SET_PAGINATION_FOR_COMMUNITY_LISTINGS':
    case 'GET_COMMUNITY_LISTINGS_REQUEST':
    case 'GET_COMMUNITY_LISTINGS_SUCCESS':
    case 'GET_COMMUNITY_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_REQUEST':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_SUCCESS':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_FAILED': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default communityListings;
